import { InputField } from "@vega-core/components/Form/Fields/InputField";
import { m } from "@vega-core/paraglide/messages";

export const StepEmail = () => (
  <div className="flex flex-col gap-6">
    <div className="body-base-regular text-text/secondary text-left">
      <p>{m.userManagement_invite_emailStepDescription1()}</p>
    </div>
    <div className="mt-4">
      <InputField label={m.formFields_email()} name="email" />
    </div>
    <div className="body-base-regular text-text/secondary text-left">
      {m.userManagement_invite_emailStepDescription2()}
    </div>
  </div>
);
